import DropdownMenu, { ActionsProps } from "../../../Inputs/DropdownMenu";

export interface ActionButtonProps {
  jobId: string;
  disabled?: boolean;
}

const ActionButton = ({ jobId, disabled = true }: ActionButtonProps) => {
  const actions: Array<ActionsProps> = [];

  const csvDownloadHref = `/api/repetitive-loss-import/${jobId}/repetitive-loss-data`;

  actions.push({
    label: "Download original .csv",
    download: true,
    href: csvDownloadHref,
    disabled,
  });

  return <DropdownMenu actions={actions} />;
};

export default ActionButton;
